import ar from '@/models/locales/ar.json';
import bn from '@/models/locales/bn.json';
import de from '@/models/locales/de.json';
import en_US from '@/models/locales/en-US.json';
import en from '@/models/locales/en.json';
import es_ES from '@/models/locales/es-ES.json';
import es from '@/models/locales/es.json';
import fr from '@/models/locales/fr.json';
import hi from '@/models/locales/hi.json';
import id from '@/models/locales/id.json';
import it from '@/models/locales/it.json';
import ja from '@/models/locales/ja.json';
import pt_PT from '@/models/locales/pt-PT.json';
import zh_CN from '@/models/locales/zh-CN.json';
import { createI18n } from 'vue-i18n';

export const i18n = createI18n({
  legacy: false,
  fallbackLocale: 'en',
  messages: {
    ar,
    bn,
    de,
    en,
    'en-US': en_US,
    es,
    'es-ES': es_ES,
    fr,
    hi,
    id,
    it,
    ja,
    'pt-PT': pt_PT,
    'zh-CN': zh_CN,
  },
  allowComposition: true,
});
